<template>
  <div>
    <div class="card p-4 mb-3">
      <Filtros
        :years="years"
        :months="months"
        :canales="canales"
        :error="errorDownLoad"
        :loading="isLoadingDownload"
        @downloadClick="handleDownloadClick"
        @search="handleSearch"
        @filtrosCambiaron="handleCambioFiltros"
      />
    </div>

    <b-tabs
      content-class="mt-3"
      v-model="activeTab"
      :style="`pointer-events: ${areDisabledTabs ? 'none' : 'auto'};`"
    >
      <b-tab title="Conversaciones">
        <div
          class="row"
          v-if="
            seHizoPrimeraBusquedaConversaciones &&
            !isLoadingGraficoMensualConversaciones &&
            !errorServiceConversaciones
          "
        >
          <div class="col-md-12 card p-4">
            <TotalesHorizontal
              :items="itemsTotalesGraficoMensualConversaciones"
            />
          </div>
          <div class="col-md-12 card p-4">
            <!-- Gráfico mensual conversaciones -->
            <Grafico
              @selectedLabel="handleSelectedLabelGraficoMensual"
              :titulos="titulosGraficoMensualConversaciones"
              :series="seriesGraficoMensualConversaciones"
              :labels="labelsGraficoMensualConversaciones"
            />

            <div style="display: flex; justify-content: flex-end">
              <date-picker
                v-model="rangeDateGraficoDiarioConversaciones"
                range
                class="mx-2 w-auto"
                type="date"
                format="YYYY-MM-DD"
                valueType="format"
                :placeholder="'Seleccione un rango'"
                :disabled-date="checkIfIsDisabledDateGraficoDiarioDate"
                :clearable="false"
              />
              <b-btn
                variant="primary"
                @click="handleBuscarGraficoDiarioClick"
                :disabled="rangeDateGraficoDiarioConversaciones.length != 2"
              >
                <i class="fas fa-search"></i>
                Buscar
              </b-btn>
            </div>

            <div class="mt-2" v-if="isLoadingGraficoDiarioConversaciones">
              <BusquedaCargando />
            </div>

            <div
              class="mt-2"
              v-if="
                isVisibleGraficoDiarioConversaciones &&
                !isLoadingGraficoDiarioConversaciones
              "
            >
              <!-- Gráfico diario conversaciones -->
              <Grafico
                :titulos="titulosGraficoDiarioConversaciones"
                :series="seriesGraficoDiarioConversaciones"
                :labels="labelsGraficoDiarioConversaciones"
              />
            </div>
          </div>
        </div>

        <template v-if="isLoadingGraficoMensualConversaciones">
          <BusquedaCargando />
        </template>

        <template v-if="!isLoadingGraficoMensualConversaciones && errorServiceConversaciones">
            <div class="col-md-12 card p-4">
                <WarningMessage />
            </div>
        </template>

        <template v-else-if="!seHizoPrimeraBusquedaConversaciones">
          <BusquedaNoRealizada />
        </template>
      </b-tab>

      <!-- Intent -->
      <b-tab title="Intent">
        <div
          class="row"
          v-if="seHizoPrimeraBusquedaIntent &&
            !isLoadingGraficoMensualIntent &&
            !errorServiceIntent
          "
        >
          <div class="col-md-12 card p-4">
            <TotalesHorizontal
              :items="itemsTotalesGraficoMensualIntent"
            />
          </div>
          <div class="col-md-12 card p-4">
            <!-- Gráfico mensual intent -->
            <Grafico
              @selectedLabel="handleSelectedLabelGraficoMensual"
              :titulos="titulosGraficoMensualIntent"
              :series="seriesGraficoMensualIntent"
              :labels="labelsGraficoMensualIntent"
            />

            <div style="display: flex; justify-content: flex-end">
              <date-picker
                v-model="rangeDateGraficoDiarioIntent"
                range
                class="mx-2 w-auto"
                type="date"
                format="YYYY-MM-DD"
                valueType="format"
                :placeholder="'Seleccione un rango'"
                :disabled-date="checkIfIsDisabledDateGraficoDiarioDate"
                :clearable="false"
              />
              <b-btn
                variant="primary"
                @click="handleBuscarGraficoDiarioClick"
                :disabled="rangeDateGraficoDiarioIntent.length != 2"
              >
                <i class="fas fa-search"></i>
                Buscar
              </b-btn>
            </div>

            <div class="mt-2" v-if="isLoadingGraficoDiarioIntent">
              <BusquedaCargando />
            </div>

            <div
              class="mt-2"
              v-if="
                isVisibleGraficoDiarioIntent && !isLoadingGraficoDiarioIntent
              "
            >
              <!-- Gráfico diario conversaciones -->
              <Grafico
                :titulos="titulosGraficoDiarioIntent"
                :series="seriesGraficoDiarioIntent"
                :labels="labelsGraficoDiarioIntent"
              />
            </div>
          </div>
        </div>

        <template v-if="isLoadingGraficoMensualIntent">
          <BusquedaCargando />
        </template>

        <template v-if="!isLoadingGraficoMensualIntent && errorServiceIntent">
            <div class="col-md-12 card p-4">
                <WarningMessage />
            </div>
        </template>

        <template v-else-if="!seHizoPrimeraBusquedaIntent">
          <BusquedaNoRealizada />
        </template>
      </b-tab>

      <!-- Agentes -->
      <b-tab title="Agentes">
        <div
          class="row"
          v-if="seHizoPrimeraBusquedaAgentes && !isLoadingGraficoMensualAgentes && !errorServiceAgentes"
        >
          <div class="col-md-12 card p-4">
            <TotalesHorizontal
              :items="itemsTotalesGraficoMensualAgentes"
            />
          </div>
          <div class="col-md-12 card p-4">
            <!-- Gráfico mensual agentes -->
            <Grafico
              @selectedLabel="handleSelectedLabelGraficoMensual"
              :titulos="titulosGraficoMensualAgentes"
              :series="seriesGraficoMensualAgentes"
              :labels="labelsGraficoMensualAgentes"
            />

            <div style="display: flex; justify-content: flex-end">
              <date-picker
                v-model="rangeDateGraficoDiarioAgentes"
                range
                class="mx-2 w-auto"
                type="date"
                format="YYYY-MM-DD"
                valueType="format"
                :placeholder="'Seleccione un rango'"
                :disabled-date="checkIfIsDisabledDateGraficoDiarioDate"
                :clearable="false"
              />
              <b-btn
                variant="primary"
                @click="handleBuscarGraficoDiarioClick"
                :disabled="rangeDateGraficoDiarioAgentes.length != 2"
              >
                <i class="fas fa-search"></i>
                Buscar
              </b-btn>
            </div>

            <div class="mt-2" v-if="isLoadingGraficoDiarioAgentes">
              <BusquedaCargando />
            </div>

            <div
              class="mt-2"
              v-if="
                isVisibleGraficoDiarioAgentes && !isLoadingGraficoDiarioAgentes
              "
            >
            <!-- Gráfico diario agentes -->
              <Grafico
                :titulos="titulosGraficoDiarioAgentes"
                :series="seriesGraficoDiarioAgentes"
                :labels="labelsGraficoDiarioAgentes"
              />
            </div>
          </div>
        </div>

        <template v-if="isLoadingGraficoMensualAgentes">
          <BusquedaCargando />
        </template>

        <template v-if="!isLoadingGraficoMensualAgentes && errorServiceAgentes">
            <div class="col-md-12 card p-4">
                <WarningMessage />
            </div>
        </template>

        <template v-else-if="!seHizoPrimeraBusquedaAgentes">
          <BusquedaNoRealizada />
        </template>
      </b-tab>

      <!-- Flujos -->
      <b-tab title="Flujos">
        <div
          class="row"
          v-if="seHizoPrimeraBusquedaFlujos && !isLoadingGraficoMensualFlujos && !errorServiceFlujos"
        >
          <div class="col-md-12 card p-4">
            <TotalesHorizontal
              :items="itemsTotalesGraficoMensualFlujos"
            />
          </div>
          <div class="col-md-12 card p-4">
            <!-- Gráfico mensual #1 flujos -->
            <Grafico
              :titulos="titulosGraficoMensualFlujos"
              :series="seriesGraficoMensualFlujos"
              :labels="labelsGraficoMensualFlujos"
            />

            <!-- Gráfico mensual #2 flujos -->
            <Grafico
              :titulos="titulos2GraficoMensualFlujos"
              :series="series2GraficoMensualFlujos"
              :labels="labels2GraficoMensualFlujos"
            />

            <div style="display: flex; justify-content: flex-end">
              <date-picker
                v-model="rangeDateGraficoDiarioFlujos"
                range
                class="mx-2 w-auto"
                type="date"
                format="YYYY-MM-DD"
                valueType="format"
                :placeholder="'Seleccione un rango'"
                :disabled-date="checkIfIsDisabledDateGraficoDiarioDate"
                :clearable="false"
              />
              <b-btn
                variant="primary"
                @click="handleBuscarGraficoDiarioClick"
                :disabled="rangeDateGraficoDiarioFlujos.length != 2"
              >
                <i class="fas fa-search"></i>
                Buscar
              </b-btn>
            </div>

            <div class="mt-2" v-if="isLoadingGraficoDiarioFlujos">
              <BusquedaCargando />
            </div>

            <div
              class="mt-2"
              v-if="
                isVisibleGraficoDiarioFlujos && !isLoadingGraficoDiarioFlujos
              "
            >
              <!-- Gráfico diario flujos -->
              <Grafico
                :titulos="titulosGraficoDiarioFlujos"
                :series="seriesGraficoDiarioFlujos"
                :labels="labelsGraficoDiarioFlujos"
              />
            </div>
          </div>
        </div>

        <template v-if="isLoadingGraficoMensualFlujos">
          <BusquedaCargando />
        </template>

        <template v-if="!isLoadingGraficoMensualFlujos && errorServiceFlujos ">
            <div class="col-md-12 card p-4">
                <WarningMessage />
            </div>
        </template>

        <template v-else-if="!seHizoPrimeraBusquedaFlujos">
          <BusquedaNoRealizada />
        </template>
      </b-tab>

      <!-- Encuesta -->
      <b-tab title="Encuestas">
        <div
          class="card"
          v-if="seHizoPrimeraBusquedaEncuestas && !isLoadingGraficoMensualEncuestas && !errorServiceEncuestas"
        >
            <EncuestasTab
                :declaration="encuestas"
            />

        </div>

        <template v-if="isLoadingGraficoMensualEncuestas">
          <BusquedaCargando />
        </template>

        <template v-if="!isLoadingGraficoMensualEncuestas && errorServiceEncuestas ">
            <div class="col-md-12 card p-4">
                <WarningMessage />
            </div>
        </template>

        <template v-else-if="!seHizoPrimeraBusquedaEncuestas">
          <BusquedaNoRealizada />
        </template>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import Grafico from "./components/generic/Grafico.vue";
import EncuestasTab from "./components/EncuestasTab.vue";
import Filtros from "./components/Filtros.vue";
import TotalesHorizontal from "./components/TotalesHorizontal.vue";
import elipseCitasService from "./services/elipseCitasServicie";
import getStartAndEndDateByYearAndMonth from "./utils/getStartAndEndDateByYearAndMonth";
import moment from "moment";
import BusquedaNoRealizada from "./components/BusquedaNoRealizada.vue";
import BusquedaCargando from "./components/BusquedaCargando.vue";
import WarningMessage from "./components/WarningMessage.vue";
import GraficoDona from './components/generic/GraficoDona.vue';

export default {
  components: {
    Grafico,
    Filtros,
    TotalesHorizontal,
    BusquedaNoRealizada,
    BusquedaCargando,
    WarningMessage,
    GraficoDona,
    EncuestasTab,
  },
  props: {
    months: Object,
    years: Array,
    canales: Array,
  },
  data() {
    return {
      cacheGraficoMensualData: {},
      cacheGraficoDiarioData: {},

      tabs: ["conversaciones", "intent", "agentes", "flujos", "encuestas"],
      activeTab: 0,

      rangeDate: [],
      idCanal: null,
      errorDownLoad:false,
      isLoadingDownload: false,

      // Conversaciones
      seHizoPrimeraBusquedaConversaciones: false,
      isLoadingGraficoMensualConversaciones: false,
      isLoadingGraficoDiarioConversaciones: false,

      isVisibleGraficoDiarioConversaciones: false,
      errorServiceConversaciones: false,
      rangeDateGraficoDiarioConversaciones: [],

      titulosGraficoMensualConversaciones: [],
      labelsGraficoMensualConversaciones: [],
      seriesGraficoMensualConversaciones: [],
      itemsTotalesGraficoMensualConversaciones: [],

      titulosGraficoDiarioConversaciones: [],
      labelsGraficoDiarioConversaciones: [],
      seriesGraficoDiarioConversaciones: [],

      // Intent
      seHizoPrimeraBusquedaIntent: false,
      isLoadingGraficoMensualIntent: false,
      isLoadingGraficoDiarioIntent: false,
      errorServiceIntent: false,

      isVisibleGraficoDiarioIntent: false,
      rangeDateGraficoDiarioIntent: [],

      titulosGraficoMensualIntent: [],
      labelsGraficoMensualIntent: [],
      seriesGraficoMensualIntent: [],
      itemsTotalesGraficoMensualIntent: [],

      titulosGraficoDiarioIntent: [],
      labelsGraficoDiarioIntent: [],
      seriesGraficoDiarioIntent: [],

      // Agentes
      isLoadingGraficoMensualAgentes: false,
      isLoadingGraficoDiarioAgentes: false,
      seHizoPrimeraBusquedaAgentes: false,
      isVisibleGraficoDiarioAgentes: false,
      errorServiceAgentes: false,
      rangeDateGraficoDiarioAgentes: [],

      titulosGraficoMensualAgentes: [],
      labelsGraficoMensualAgentes: [],
      seriesGraficoMensualAgentes: [],
      itemsTotalesGraficoMensualAgentes: [],

      titulosGraficoDiarioAgentes: [],
      labelsGraficoDiarioAgentes: [],
      seriesGraficoDiarioAgentes: [],

      // Flujos
      seHizoPrimeraBusquedaFlujos: false,
      isLoadingGraficoMensualFlujos: false,
      isLoadingGraficoDiarioFlujos: false,
      errorServiceFlujos: false,

      isVisibleGraficoDiarioFlujos: false,
      rangeDateGraficoDiarioFlujos: [],

      titulosGraficoMensualFlujos: [],
      labelsGraficoMensualFlujos: [],
      seriesGraficoMensualFlujos: [],
      itemsTotalesGraficoMensualFlujos: [],

      titulos2GraficoMensualFlujos: [],
      labels2GraficoMensualFlujos: [],
      series2GraficoMensualFlujos: [],
      items2TotalesGraficoMensualFlujos: [],

      titulosGraficoDiarioFlujos: [],
      labelsGraficoDiarioFlujos: [],
      seriesGraficoDiarioFlujos: [],
      
      encuestas:{
        total:200,
        grafico:{
            series:[

                {
                    name: 'Chatbot',
                    data: [60, 20, 10, 10]
                }, {
                    name: 'Whatsapp',
                    data: [50, 10, 20, 20]
                }
            ],
            categories: ['Buena', 'Regular', 'Mala', 'Sin Respuesta'],

        },
        indicadores:[
            {
                title:'Whatsapp',
                items:[
                    {
                        label:'Total de Encuestas',
                        value:150,
                    },
                    {
                        label:'Total de Encuestas Buenas',
                        value:50,
                    },
                    {
                        label:'Total de Encuestas Regulares',
                        value:50,
                    },
                    {
                        label:'Total de Encuestas Malas',
                        value:25,
                    },
                    {
                        label:'Total de Encuestas Sin respuestas',
                        value:25,
                    },

                ]
            },
            {
                title:'Chatbot',
                items:[
                    {
                        label:'Total de Encuestas',
                        value:150,
                    },
                    {
                        label:'Total de Encuestas Buenas',
                        value:50,
                    },
                    {
                        label:'Total de Encuestas Regulares',
                        value:50,
                    },
                    {
                        label:'Total de Encuestas Malas',
                        value:25,
                    },
                    {
                        label:'Total de Encuestas Sin respuestas',
                        value:25,
                    },

                ]
            }
        ]
      },
      seHizoPrimeraBusquedaEncuestas:false,
      isLoadingGraficoMensualEncuestas:false,
      errorServiceEncuestas:false,
    }
  },
  computed: {
    /** @returns {String} Nombre del tab activo */
    activeTabLabel() {
      return this.tabs[this.activeTab];
    },
    /** @returns {Boolean} Indica si se está cargando algún dato de conversaciones */
    isLoadignConversaciones() {
      return (
        this.isLoadingGraficoMensualConversaciones ||
        this.isLoadingGraficoDiarioConversaciones
      );
    },
    /** @returns {Boolean} Indica si se está cargando algún dato de intent */
    isLoadignIntent() {
      return (
        this.isLoadingGraficoMensualIntent || this.isLoadingGraficoDiarioIntent
      );
    },
    /** @returns {Boolean} Indica si se está cargando algún dato de agentes */
    isLoadignAgentes() {
      return (
        this.isLoadingGraficoMensualAgentes ||
        this.isLoadingGraficoDiarioAgentes
      );
    },
    /** @returns {Boolean} Indica si se está cargando algún dato de flujos */
    isLoadignFlujos() {
      return (
        this.isLoadingGraficoMensualFlujos || this.isLoadingGraficoDiarioFlujos
      );
    },
    /** @returns {Boolean} Indica si se está cargando algún dato */
    isLoadingData() {
      return (
        this.isLoadignConversaciones ||
        this.isLoadignIntent ||
        this.isLoadignAgentes ||
        this.isLoadignFlujos
      );
    },
    /** @returns {Boolean} Indica si las tabs están deshabilitadas */
    areDisabledTabs() {
      return this.isLoadingData;
    },
    filtrosParaPDFQueryString() {
      const [startDate, endDate] = this.rangeDate

      let filtros = new URLSearchParams({
        fecha_inicio: startDate ?? '',
        fecha_termino: endDate ?? '',
        canal: this.idCanal ?? '',
      })

      return filtros.toString();
    },
    exportarCsvURL() {
      let url = new URL(serverRoutes.descargarServicios)
      url.search = this.filtrosParaPDFQueryString
      return url.toString()
    },
  },
  methods: {
    /** @returns {void} Maneja el evento descargar */
    handleDownloadClick() {
      this.isLoadingDownload = true;
      elipseCitasService.getReporte(this.exportarCsvURL)
      .then(()=>{
        this.errorDownLoad = false;
      })
      .catch(()=>{
        this.errorDownLoad = true;
      })
      .finally(()=>{
        this.isLoadingDownload = false;
      });
    },
    /**
     * @param {Object} payload
     * @param {String} payload.startDate Formato YYYY-MM-DD
     * @param {String} payload.endDate Formato YYYY-MM-DD
     * @param {Number} payload.canal
     * @returns {void}
     * @description Maneja el evento de búsqueda del componente Filtros
     */
    handleCambioFiltros({ startDate, endDate, canal }) {
      this.idCanal = canal;
      this.rangeDate = [startDate, endDate];
    },
    handleSearch({ startDate, endDate, canal }) {
      const type = this.activeTabLabel;
      this.startGetAndsetGraficoMensualData({
        startDate,
        endDate,
        canal,
        type,
      });
    },

    // =====================================
    // Gráfico mensual
    // =====================================

    /**
     * @param {Object} payload
     * @param {Array} payload.titulos
     * @param {Array} payload.labels
     * @param {Array} payload.series
     * @param {Array} payload.totales
     * @returns {void}
     * @description Setea los datos del gráfico mensual de conversaciones
     */
    setGraficoMensualConversacionesData({ titulos, labels, series, totales }) {
      this.titulosGraficoMensualConversaciones = titulos;
      this.labelsGraficoMensualConversaciones = labels;
      this.seriesGraficoMensualConversaciones = series;
      this.itemsTotalesGraficoMensualConversaciones = totales;
    },
    /**
     * @param {Object} payload
     * @param {Array} payload.titulos
     * @param {Array} payload.labels
     * @param {Array} payload.series
     * @param {Array} payload.totales
     * @returns {void}
     * @description Setea los datos del gráfico mensual de intent
     */
    setGraficoMensualIntentData({ titulos, labels, series, totales }) {
      this.titulosGraficoMensualIntent = titulos;
      this.labelsGraficoMensualIntent = labels;
      this.seriesGraficoMensualIntent = series;
      this.itemsTotalesGraficoMensualIntent = totales;
    },
    /**
     * @param {Object} payload
     * @param {Array} payload.titulos
     * @param {Array} payload.labels
     * @param {Array} payload.series
     * @param {Array} payload.totales
     * @returns {void}
     * @description Setea los datos del gráfico mensual de agentes
     */
    setGraficoMensualAgentesData({ titulos, labels, series, totales }) {
      this.titulosGraficoMensualAgentes = titulos;
      this.labelsGraficoMensualAgentes = labels;
      this.seriesGraficoMensualAgentes = series;
      this.itemsTotalesGraficoMensualAgentes = totales;
    },
    /**
     * @param {Object} payload
     * @param {Array} payload.titulos
     * @param {Array} payload.labels
     * @param {Array} payload.series
     * @param {Array} payload.totales
     * @returns {void}
     * @description Setea los datos del gráfico mensual de flujos
     */
    setGraficoMensualFlujosData({
      titulos,
      labels,
      series,
      totales,
      titulos2,
      labels2,
      series2,
    }) {
      this.titulosGraficoMensualFlujos = titulos;
      this.labelsGraficoMensualFlujos = labels;
      this.seriesGraficoMensualFlujos = series;
      this.itemsTotalesGraficoMensualFlujos = totales;

      this.titulos2GraficoMensualFlujos = titulos2;
      this.labels2GraficoMensualFlujos = labels2;
      this.series2GraficoMensualFlujos = series2;
    },
    /**
     * Comprueba si una fecha está dentro de un rango de fechas especificado por las fechas de inicio y finalización proporcionadas.
     *
     * @param {string} date - La fecha a verificar en formato "YYYY-MM-DD".
     * @return {boolean} `true` si la fecha no está dentro del rango especificado, `false` si la fecha está dentro del rango.
     */
    checkIfIsDisabledDateGraficoDiarioDate(date) {
      const [startDateString, endDateString] = this.rangeDate;

      const startDate = moment(startDateString, "YYYY-MM-DD");
      const endDate = moment(endDateString, "YYYY-MM-DD");
      const dateToCheck = moment(date);

      return !dateToCheck.isBetween(startDate, endDate, null, "[]");
    },
    /**
     * @param {Object} payload
     * @param {String} payload.startDate Formato YYYY-MM-DD
     * @param {String} payload.endDate Formato YYYY-MM-DD
     * @param {Number} payload.canal
     * @returns {Promise}
     * @description Obtiene los datos del gráfico mensual de conversaciones
     */
    startGetAndsetGraficoMensualData({ startDate, endDate, canal, type }) {
      this.resetGraficoDiario(type);

      switch (type) {
        case "conversaciones":
          this.isLoadingGraficoMensualConversaciones = true;
          break;
        case "intent":
          this.isLoadingGraficoMensualIntent = true;
          break;
        case "agentes":
          this.isLoadingGraficoMensualAgentes = true;
          break;
        case "flujos":
          this.isLoadingGraficoMensualFlujos = true;
          break;
        case "encuestas":
          this.isLoadingGraficoMensualEncuestas = true;
          break;

        default:
          break;
      }

      // Cache
      const hoy = moment();
      const rangoDeFechasIncluyeElDiaActual = moment(endDate).isSameOrAfter(
        hoy,
        "day"
      );

      if (!rangoDeFechasIncluyeElDiaActual) {
        const dataFromCache = this.getGraficoMensualDataFromCache({
          startDate,
          endDate,
          canal,
          type,
        });

        if (dataFromCache) {
          this.setGraficoMensualDataByResponse({
            data: dataFromCache,
            filtros: { startDate, endDate, canal, type },
          });
          return;
          // return Promise.resolve({ data: dataFromCache });
        }
      }

      return elipseCitasService
        .getGraficoMensualData({
          startDate,
          endDate,
          canal,
          type,
        })
        .then((data) => {
          // const { data } = response;
          this.setGraficoMensualDataByResponse({
            data,
            filtros: { startDate, endDate, canal, type },
          });
        }).catch(() => {
            this.setErrorServer(type);
        });
    },
    /**
     * @param {Object} payload
     * @param {String} payload.startDate Formato YYYY-MM-DD
     * @param {String} payload.endDate Formato YYYY-MM-DD
     * @param {Number} payload.canal
     * @returns {Promise}
     * @description Obtiene los datos del gráfico mensual desde cache
     */
    getGraficoMensualDataFromCache({ startDate, endDate, canal, type }) {
      const key = this.getGraficoMensualDataCacheKey({
        startDate,
        endDate,
        canal,
        type,
      });
      // Cache
      const data = this.cacheGraficoMensualData[key];
      return data ?? null;
    },
    getGraficoMensualDataCacheKey({ startDate, endDate, canal, type }) {
      return `${startDate}-${endDate}-${canal}-${type}`;
    },
    setGraficoMensualDataByResponse({ data, filtros }) {
      const { startDate, endDate, canal, type } = filtros;
      const { titulos, labels, series, totales } = data;
      switch (type) {
        case "conversaciones":
          this.setGraficoMensualConversacionesData({
            titulos,
            labels,
            series,
            totales,
          });
          if (!this.seHizoPrimeraBusquedaConversaciones) {
            this.seHizoPrimeraBusquedaConversaciones = true;
          }
          this.isLoadingGraficoMensualConversaciones = false;
          this.errorServiceConversaciones = false;
          break;
        case "intent":
          this.setGraficoMensualIntentData({
            titulos,
            labels,
            series,
            totales,
          });
          if (!this.seHizoPrimeraBusquedaIntent) {
            this.seHizoPrimeraBusquedaIntent = true;
          }
          this.isLoadingGraficoMensualIntent = false;
          this.errorServiceIntent = false;
          break;
        case "agentes":
          this.setGraficoMensualAgentesData({
            titulos,
            labels,
            series,
            totales,
          });
          if (!this.seHizoPrimeraBusquedaAgentes) {
            this.seHizoPrimeraBusquedaAgentes = true;
          }
          this.isLoadingGraficoMensualAgentes = false;
          this.errorServiceAgentes = false;
          break;
        case "flujos":
          const { titulos2, labels2, series2 } = data;

          this.setGraficoMensualFlujosData({
            titulos,
            labels,
            series,
            totales,
            titulos2,
            labels2,
            series2,
          });

          if (!this.seHizoPrimeraBusquedaFlujos) {
            this.seHizoPrimeraBusquedaFlujos = true;
          }
          this.isLoadingGraficoMensualFlujos = false;
          this.errorServiceFlujos = false;
          break;
          case "encuestas":
            const { encuestas } = data;

            this.encuestas = encuestas

            if (!this.seHizoPrimeraBusquedaEncuestas) {
                this.seHizoPrimeraBusquedaEncuestas = true;
            }
            this.isLoadingGraficoMensualEncuestas = false;
            this.errorServiceEncuestas = false;
          break;
        default:
          break;
      }

      // cache
      this.cacheGraficoMensualData[
        this.getGraficoMensualDataCacheKey({
          startDate,
          endDate,
          canal,
          type,
        })
      ] = data;
    },
    /**
     * @param {Object} label
     * @param {String} label.value Formato YYYY-MM
     * @returns {void}
     * @description Maneja el evento de selección de un label del gráfico mensual
     */
    handleSelectedLabelGraficoMensual(label) {
      const [year, month] = label.value.split("-");
      const { startDate, endDate } = getStartAndEndDateByYearAndMonth(
        year,
        month
      );

      this.rangeDateGraficoDiarioConversaciones = [startDate, endDate];
      const canal = this.idCanal;
      const type = this.activeTabLabel;
      this.startGetAndSetGraficoDiarioData({ startDate, endDate, canal, type });
    },

    // =====================================
    // Conversaciones: Gráfico diario
    // =====================================

    resetGraficoDiario(type) {
      switch (type) {
        case "conversaciones":
          this.labelsGraficoDiarioConversaciones = [];
          this.seriesGraficoDiarioConversaciones = [];
          this.itemsTotalesGraficoDiarioConversaciones = [];
          this.isVisibleGraficoDiarioConversaciones = false;
          this.rangeDateGraficoDiarioConversaciones = [];
          break;
        case "intent":
          this.labelsGraficoDiarioIntent = [];
          this.seriesGraficoDiarioIntent = [];
          this.itemsTotalesGraficoDiarioIntent = [];
          this.isVisibleGraficoDiarioIntent = false;
          this.rangeDateGraficoDiarioIntent = [];
          break;
        case "agentes":
          this.labelsGraficoDiarioAgentes = [];
          this.seriesGraficoDiarioAgentes = [];
          this.itemsTotalesGraficoDiarioAgentes = [];
          this.isVisibleGraficoDiarioAgentes = false;
          this.rangeDateGraficoDiarioAgentes = [];
          break;
        case "flujos":
          this.labelsGraficoDiarioFlujos = [];
          this.seriesGraficoDiarioFlujos = [];
          this.itemsTotalesGraficoDiarioFlujos = [];
          this.isVisibleGraficoDiarioFlujos = false;
          this.rangeDateGraficoDiarioFlujos = [];
          break;

        default:
          break;
      }
    },

    /**
     * @returns {void}
     * @description Maneja el evento de búsqueda del componente Filtros
     */
    handleBuscarGraficoDiarioClick() {
      const type = this.activeTabLabel;

      let rangeDate = [];
      switch (this.activeTabLabel) {
        case "conversaciones":
          rangeDate = this.rangeDateGraficoDiarioConversaciones;
          break;
        case "intent":
          rangeDate = this.rangeDateGraficoDiarioIntent;
          break;
        case "agentes":
          rangeDate = this.rangeDateGraficoDiarioAgentes;
          break;
        case "flujos":
          rangeDate = this.rangeDateGraficoDiarioFlujos;
          break;

        default:
          break;
      }
      const [startDate, endDate] = rangeDate;

      // Create moment objects for start and end dates
      const startDateMoment = moment(startDate, "YYYY-MM-DD");
      const endDateMoment = moment(endDate, "YYYY-MM-DD");

      const diffInDays = endDateMoment.diff(startDateMoment, "days");
      if (diffInDays > 60) {
        this.$swal({
          icon: "error",
          title: "Oops!",
          text: "El rango a buscar puede ser de máximo 60 días",
        });
        return;
      }

      const canal = this.idCanal;
      this.startGetAndSetGraficoDiarioData({ startDate, endDate, canal, type });
    },
    /**
     * @param {Object} payload
     * @param {Array} payload.titulos
     * @param {Array} payload.labels
     * @param {Array} payload.series
     * @returns {void}
     * @description Setea los datos del gráfico diario
     */
    setGraficoDiarioConversacionesData({ titulos, labels, series }) {
      this.titulosGraficoDiarioConversaciones = titulos;
      this.labelsGraficoDiarioConversaciones = labels;
      this.seriesGraficoDiarioConversaciones = series;
    },
    /**
     * @param {Object} payload
     * @param {Array} payload.titulos
     * @param {Array} payload.labels
     * @param {Array} payload.series
     * @returns {void}
     * @description Setea los datos del gráfico diario
     */
    setGraficoDiarioIntentData({ titulos, labels, series }) {
      this.titulosGraficoDiarioIntent = titulos;
      this.labelsGraficoDiarioIntent = labels;
      this.seriesGraficoDiarioIntent = series;
    },
    setGraficoDiarioAgentesData({ titulos, labels, series }) {
      this.titulosGraficoDiarioAgentes = titulos;
      this.labelsGraficoDiarioAgentes = labels;
      this.seriesGraficoDiarioAgentes = series;
    },
    setGraficoDiarioFlujosData({ titulos, labels, series }) {
      this.titulosGraficoDiarioFlujos = titulos;
      this.labelsGraficoDiarioFlujos = labels;
      this.seriesGraficoDiarioFlujos = series;
    },
    /**
     * @param {Object} payload
     * @param {String} payload.startDate Formato YYYY-MM-DD
     * @param {String} payload.endDate Formato YYYY-MM-DD
     * @param {Number} payload.canal
     * @returns {Promise}
     * @description Obtiene los datos del gráfico diario
     */
    startGetAndSetGraficoDiarioData({ startDate, endDate, canal, type }) {
      switch (type) {
        case "conversaciones":
          this.isLoadingGraficoDiarioConversaciones = true;
          break;
        case "intent":
          this.isLoadingGraficoDiarioIntent = true;
          break;
        case "agentes":
          this.isLoadingGraficoDiarioAgentes = true;
          break;
        case "flujos":
          this.isLoadingGraficoDiarioFlujos = true;
          break;

        default:
          break;
      }

      const hoy = moment();
      const rangoDeFechasIncluyeElDiaActual = moment(endDate).isSameOrAfter(
        hoy,
        "day"
      );

      if (!rangoDeFechasIncluyeElDiaActual) {
        const dataFromCache = this.getGraficoDiarioDataFromCache({
          startDate,
          endDate,
          canal,
          type,
        });

        if (dataFromCache) {
          this.setGraficoDiarioDataByResponse({
            data: dataFromCache,
            filtros: { startDate, endDate, canal, type },
          });
          return;
        }
      }

      return elipseCitasService
        .getGraficoDiarioData({ startDate, endDate, canal, type })
        .then((data) => {
          this.setGraficoDiarioDataByResponse({
            data,
            filtros: { startDate, endDate, canal, type },
          });
        }).catch(() => {
            this.setErrorServer(type);
        });
    },
    /**
     * @param {Object} payload
     * @param {String} payload.startDate Formato YYYY-MM-DD
     * @param {String} payload.endDate Formato YYYY-MM-DD
     * @param {Number} payload.canal
     * @returns {Promise}
     * @description Obtiene los datos del gráfico diario desde cache
     */
    getGraficoDiarioDataFromCache({ startDate, endDate, canal, type }) {
      const key = this.getGraficoDiarioDataCacheKey({
        startDate,
        endDate,
        canal,
        type,
      });

      const data = this.cacheGraficoDiarioData[key];
      return data ?? null;
    },
    /**
     * @param {Object} payload
     * @param {String} payload.startDate Formato YYYY-MM-DD
     * @param {String} payload.endDate Formato YYYY-MM-DD
     * @param {Number} payload.canal
     * @returns {String}
     * @description Obtiene los datos del gráfico diario
     */
    getGraficoDiarioDataCacheKey({ startDate, endDate, canal, type }) {
      return `${startDate}-${endDate}-${canal}-${type}`;
    },
    /**
     * @param {Object} payload
     * @param {Object} payload.data
     * @param {Object} payload.filtros
     * @param {String} payload.filtros.startDate Formato YYYY-MM-DD
     * @param {String} payload.filtros.endDate Formato YYYY-MM-DD
     * @param {Number} payload.filtros.canal
     * @returns {void}
     * @description Setea los datos del gráfico diario
     */
    setGraficoDiarioDataByResponse({ data, filtros }) {
      const { startDate, endDate, canal, type } = filtros;
      const { titulos, labels, series } = data;

      switch (type) {
        case "conversaciones":
          this.setGraficoDiarioConversacionesData({
            titulos,
            labels,
            series,
          });
          this.isVisibleGraficoDiarioConversaciones = true;
          this.isLoadingGraficoDiarioConversaciones = false;
          this.errorServiceConversaciones = false;
          break;
        case "intent":
          this.setGraficoDiarioIntentData({ titulos, labels, series });
          this.isVisibleGraficoDiarioIntent = true;
          this.isLoadingGraficoDiarioIntent = false;
          this.errorServiceIntent = false;
          break;

        case "agentes":
          this.setGraficoDiarioAgentesData({ titulos, labels, series });
          this.isVisibleGraficoDiarioAgentes = true;
          this.isLoadingGraficoDiarioAgentes = false;
          this.errorServiceAgentes = false;
          break;

        case "flujos":
          this.setGraficoDiarioFlujosData({ titulos, labels, series });
          this.isVisibleGraficoDiarioFlujos = true;
          this.isLoadingGraficoDiarioFlujos = false;
          this.errorServiceFlujos = false;
          break;

        default:
          break;
      }

      const key = this.getGraficoDiarioDataCacheKey({
        startDate,
        endDate,
        canal,
        type,
      });
      this.cacheGraficoDiarioData[key] = data;
    },
    /**
     * @description setiar error en los servicios
     */
    setErrorServer(type){
        switch (type) {
        case "conversaciones":
            this.isLoadingGraficoMensualConversaciones = false;
            this.errorServiceConversaciones = true;
          break;
        case "intent":
            this.isLoadingGraficoMensualIntent = false;
            this.errorServiceIntent = true;
          break;
        case "agentes":
            this.isLoadingGraficoMensualAgentes = false;
            this.errorServiceAgentes = true;
          break;
        case "flujos":
            this.isLoadingGraficoMensualFlujos = false;
            this.errorServiceFlujos = true;
          break;
        case "encuestas":
            this.isLoadingGraficoMensualEncuestas = false;
            this.errorServiceEncuestas = true;
          break;

        default:
          break;
      }

    },
  },
  watch: {
    /**
     * @param {String} value
     * @returns {void}
     * @description Se ejecuta cuando cambia el valor de activeTabLabel
     */
    activeTabLabel(value) {
      const [startDate, endDate] = this.rangeDate;
      const canal = this.idCanal;
      const type = value;
      if (!startDate || !endDate || !type) return;
      this.startGetAndsetGraficoMensualData({
        startDate,
        endDate,
        canal,
        type,
      });
    },
  },
};
</script>

<style>
.nav-tabs {
  background-color: white;
}

.tab-content {
  margin-top: 0 !important;
}
</style>
